import React, { useState } from "react";
import Input from "../../form/Input"; import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import api from "../../../api";

export default function RegistrationForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      setLoading(true);
      const { data } = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}colleges/register`,
        formData
      );
      
      toast.success(data?.message || "Registration successful!");
      console.log("Response Data:", data);

      setFormData({ name: "", email: "", phone: "", password: "", confirmPassword: "" });
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <form onSubmit={handleSubmit} className="flex flex-wrap">
        <Input md={6} id="name" name="name" placeholder="Enter College name" value={formData.name} onChange={handleChange} />
        <Input md={6} id="email" name="email" type="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} />
        <Input md={6} id="phone" name="phone" type="tel" placeholder="Enter phone number" value={formData.phone} onChange={handleChange} />
        <Input md={6} id="address" name="address" type="text" placeholder="Enter address" value={formData.address} onChange={handleChange} />
        <Input md={6} id="password" name="password" type="password" placeholder="Enter password" value={formData.password} onChange={handleChange} />
        <Input md={6} id="confirmPassword" label="Confirm Password" name="confirmPassword" type="password" placeholder="Confirm password" value={formData.confirmPassword} onChange={handleChange} />

        <button
          type="submit"
          disabled={loading}
          className={`w-full bg-indigo-600 text-white py-2 mt-4 rounded-md transition ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-indigo-700"}`}
        >
          {loading ? "Registering..." : "Register"}
        </button>
      </form>
      <p className="mt-5 text-center text-sm/6 text-gray-500">
            Alredy Registerd {" "}
            <Link to="/college/login" className="font-semibold text-indigo-600 hover:text-indigo-500">
              Login Here
            </Link>
          </p>
    </>
  );
}
